var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.73438L2.3275 2.06254C2.81715 1.54825 3.40633 1.13897 4.05918 0.8596C4.71203 0.580231 5.41489 0.43662 6.125 0.437504C9.02344 0.437504 11.375 2.78907 11.375 5.6875C11.375 8.58594 9.02344 10.9375 6.125 10.9375C5.03918 10.9374 3.98006 10.6008 3.09341 9.97406C2.20676 9.34728 1.53615 8.46111 1.17387 7.4375",
    stroke: "#262F5F",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000184774 1.35139V4.37506C0.000184774 4.49109 0.0462782 4.60237 0.128325 4.68442C0.210372 4.76646 0.321653 4.81256 0.437685 4.81256H3.46136C3.85128 4.81256 4.04651 4.34143 3.77089 4.0658L0.746943 1.04185C0.471318 0.765683 0.000184774 0.961464 0.000184774 1.35139Z",
    fill: "#262F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegen);
export default __webpack_public_path__ + "static/media/regen.48c63200aa9c8ed9dced7297088c1634.svg";
export { ForwardRef as ReactComponent };